<template>
  <div>
    <b-col>
      <div class="row">
        <div class="col-sm-8">&nbsp;</div>
        <div class="col-sm-4 text-right">
          <button
            class="btn btn-sm btn-success"
            type="button"
            @click="addStudy()"
            :disabled="!CREATE"
          >
            Añadir estudio de bienes
          </button>
        </div>
      </div>
    </b-col>

    <section class="proj-page-section comments">
      <section
        class="without"
        v-if="!lstStudies.length > 0"
        style="margin-top: 0px"
      >
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_datos.png" alt width="150px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay estudios de bienes
              <br />en este deudor.
            </h4>
          </div>
        </div>
      </section>

      <section v-else class="mt-2">
        <b-table
          :hover="true"
          :striped="true"
          :bordered="false"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="lstStudies"
          :fields="fields"
        >
          <template slot="date" slot-scope="data">{{
            formatDate(data.item.date)
          }}</template>

          <template slot="created_at" slot-scope="data">{{
            formatDate(data.item.created_at)
          }}</template>

          <template slot="actions" slot-scope="data">
            <!-- <template v-slot:cell(actions)="data"> -->
            <b-button
              size="sm"
              variant="primary"
              class="mr-1"
              title="ver"
              @click="viewStudy(data.item)"
              :disabled="!READ"
            >
              <i class="fa fa-eye"></i>
            </b-button>

            <b-button
              size="sm"
              variant="success"
              class="mr-1"
              title="Editar"
              @click="editStudy(data.item)"
              :disabled="!UPDATE"
            >
              <i class="fa fa-edit"></i>
            </b-button>

            <b-button
              size="sm"
              variant="warning"
              class="mr-1"
              title="Descargar Documento"
              @click="dowloadFile(data.item.id)"
              :disabled="!READ"
            >
              <i class="fa fa-download"></i>
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              @click="deleteStudy(data.item)"
              title="Eliminar"
              :disabled="!DELETE"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
        <pagination
          class="mb-0"
          :data="laravelData"
          @pagination-change-page="getStudies"
          :limit="5"
          :show-disabled="true"
          :size="'small'"
          :align="'right'"
        >
          <span slot="prev-nav">Anterior</span>
          <span slot="next-nav">Siguiente</span>
        </pagination>
      </section>
    </section>

    <!-- MODAL PARA EL FORMULARIO -->
    <div class="modal fade" id="dlgStudy">
      <div class="modal-dialog modal-dialog-centered modal-success modal">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">ESTUDIO DE BIENES</h4>
            <button type="button" class="close" @click="closeStudy()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="saveStudy()"
              method="post"
              v-if="study.debtor_id"
              enctype="multipart/form-data"
            >
              <b-row>
                <b-col cols="11" sm="11" class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="danger">
                        <b>Por favor corrige los siguientes errores:</b>
                        <ul>
                          <li v-for="(error, index) in errores" :key="index">
                            {{ error }}
                          </li>
                        </ul>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbEstado">Estado</label>
                        <b-form-select
                          v-model="study.status"
                          id="cmbEstado"
                          :disabled="disableStudy"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Seleccione --
                            </option>
                          </template>
                          <option value="P">Positivo</option>
                          <option value="N">Negativo</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtFechaEstudio">Fecha estudio</label>
                        <b-form-input
                          type="date"
                          id="txtFechaEstudio"
                          v-model="study.date"
                          :disabled="disableStudy"
                          :max="maxDate"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>


                  <b-row v-if="disableStudy == false">
                    <b-col sm="12">
                      <label>Subir documento</label>
                      <b-form-file
                        :browse-text="'Buscar'"
                        v-model="file"
                        :state="Boolean(file)"
                        v-on:change="onFileChange"
                        placeholder="Elija un archivo o suéltelo aquí ..."
                        drop-placeholder="Suelta el archivo aquí ..."
                      ></b-form-file>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtComentario">Comentario</label>
                        <b-form-textarea
                          rows="4"
                          id="txtComentario"
                          no-resize
                          v-model="study.description"
                          :disabled="disableStudy"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disableStudy">
                    <b-col sm="4" class="center-block">
                      <b-button
                        type="submit"
                        variant="success"
                        class="btn-sm col-sm-12"
                        :disabled="disableStudy"
                        >Guardar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA EL FORMULARIO -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "StudyGood",
  props: {
    debtor_id: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      // CABECERAS PARA LA TABLA DE LOS AGREEMENTS
      fields: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column",
        },

        { key: "status", label: "Estado" },
        { key: "date", label: "Fecha estudio" },
        { key: "created_at", label: "Fecha cargue" },
        { key: "user_name", label: "Creado por" },
        { key: "actions", label: "Opciones" },
      ],
      laravelData: {},
      lstStudies: [],
      isEdit: false,
      disabled: false,
      datos: [],
      errores: [],
      isEditStudy: false,
      disableStudy: false,
      study: {
        date: null,
        debtor_id: null,
        status: null,
        description: null
      },
      file: null,
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  created() {
    this.enabledActions();
    this.getStudies();
  },

  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;

      switch (this.role_id) {
        case "6": // CLIENTE
          this.CREATE = false;
          this.READ = true;
          this.UPDATE = false;
          this.DELETE = false;
          break;
      }
    },
    getStudies: function (page = 1) {
      showLoader();

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}studygoods/debtor/${this.debtor_id}?token=${this.token}&page=${page}`;

      this.$http
        .get(url, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);

            this.lstStudies = response.data.data.data;
            this.laravelData = response.data.data;

            // this.pagination = setPaginator(response.data.data);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    addStudy() {
      this.errores = [];
      $("#dlgStudy").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEditStudy = false;
      this.file = null;

      // INICIALIZAR LOS CAMPOR DEL ACUERDO
      //this.study.date = null;
      this.study.debtor_id = this.debtor_id;
      this.study.status = "P";
      this.study.description = null;

      $("#dlgStudy").modal("show");
    },
    editStudy(item) {
      this.errores = [];
      $("#dlgStudy").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.study = Object.assign({}, item);
      this.file = null;
      this.isEditStudy = true;
      $("#dlgStudy").modal("show");
    },
    viewStudy(item) {
      this.errores = [];
      console.log(item);
      $("#dlgStudy").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.study = Object.assign({}, item);
      this.disableStudy = true;
      $("#dlgStudy").modal("show");
    },
    dowloadFile(id){

      showLoader();

      // LISTADO DE DOCUMENTOS DEL ESTUDIO DE BIENES
      let data = {
        table: 'study_goods',
        table_id: id,
        process_id: 2,
      };

      let docs = [];

      this.$http
        .post(
          `${this.$urlApi}documents/get?token=${this.token}`, JSON.stringify(data),
          { headers: { "Content-Type": "application/json" } }
        )
        .then(
          function (response) {
            console.log(response);
            docs = response.data.data;
            if(docs.length > 0){
              let doc = docs[0];

              window.open(`${this.$urlApi}file/${doc.name}?token=${this.token}`);
            }

            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    saveStudy() {
      this.errores = [];
      if (this.isEditStudy) {
        this.updateStudy();
      } else {
        this.$swal({
          title: "Guardar",
          text: "¿Está seguro que toda la información ingresada es correcta?",
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Volver",
          confirmButtonText: "Si",
        }).then((result) => {
          if (result.value) {
            this.createStudy();
          }
        });
      }
    },
    createStudy() {
      showLoader();

      this.datos = JSON.stringify(this.study);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.study));
      formData.append("document", this.file);

      this.$http
        .post(`${this.$urlApi}studygoods?token=${this.token}`, formData, {
          headers: { "Content-Type": undefined },
        })
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Estudio de bienes guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL ESTUDIO GUARDADO
              this.study.debtor_id = null;
              this.getStudies();
              $("#dlgStudy").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    updateStudy() {
      // COMO ES UN OBJETO FormData SE DEBE ENVIAR UN POST Y CAMBIAR EL METODO A PUT, SOLO SIRVE PARA LARAVEL
      showLoader();

      this.datos = JSON.stringify(this.study);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.study));
      formData.append("document", this.file);
      formData.append("_method", "PUT");

      this.$http
        .post(
          `${this.$urlApi}studygoods/${this.study.id}?token=${this.token}`,
          formData,
          { headers: { "Content-Type": undefined } }
        )
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Estudio de bienes actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL ESTUDIO GUARDADO
              this.study.debtor_id = null;
              this.getStudies();
              $("#dlgStudy").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteStudy(item) {

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el estudio de bienes ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(
              `${this.$urlApi}studygoods/${item.id}?token=${this.token}`,
              { headers: { "Content-Type": "application/json" } }
            )
            .then(function (response) {
              console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Estudio de bienes eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getStudies();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    closeStudy() {
      this.isEditStudy = false;
      this.disableStudy = false;
      $("#dlgStudy").modal("hide");
    },
    onFileChange(e) {
      console.log(e.target.files[0]);
      this.file = e.target.files[0];
    },
  },
};
</script>
